<template>
    <div class="body">
    <div class="db_bg">
      <div class="db_header">
				<div class="db_header_title"></div>
      </div>
      <div class="db_body">
				<dataCenter :oid="oid" :org="org"/>
      </div>
    </div>
  </div>
</template>

<script>
import dataCenter from './dataCenter'
export default {
	components:{
		dataCenter
	},
  data() {
    return {
      type: 1,
      oid: this.$route.query.oid,
      org: this.$route.query.org,
      scourseLength: 0,
    };
  },
  methods: {
    setType(type) {
      this.type = type;
    },
    getData() {
			return console.log('获取数据')
      // this.isLoading = true;
      // let params = [
      //   {
      //     oid: this.oid,
      //     org: this.org,
      //   },
      // ];
      // this.ajax
      //   .post(this.$store.state.api + "getCourseLength", params)
      //   .then((res) => {
      //     this.isLoading = false;

      //     this.scourseLength = res.data[0][0].count;
      //     this.$forceUpdate();
      //   })
      //   .catch((err) => {
      //     this.isLoading = false;
      //     console.error(err);
      //   });
    },
  },
  mounted() {
    // this.getData();
  },
}
</script>

<style scoped>
.body {
  height: 100%;
  width: 100%;
  min-width: 1550px;
  min-height: 750px;
  background: #e7f3fe;
  display: flex;
  align-items: center;
  justify-content: center;
}

.db_bg {
  width: calc(100% - 30px);
  height: calc(100% - 30px);
  /* padding: 10px; */
  border-radius: 8px;
  box-sizing: border-box;
  border: 2px solid #3681FC3D;
  box-shadow: 20px 20px 80px 0px #3681FC3D inset;
}

.db_header {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  position: relative;
  /* background: #fff; */
  align-items: center;
}

.db_header:after {
  content: "";
    position: absolute;
    width: 50%;
    height: 2px;
    bottom: 0.5px;
    left: 50%;
    z-index: 1;
    background: linear-gradient(90deg, #9ac1fd 0%, rgba(134, 179, 253, 0) 91.13%);
}

.db_header_title {
  /* background-image: url("../../../assets/icon/test/data_title.png"); */
  background-image: url("../../../../assets/icon/test/data_title2.png");
  width: 290px;
  height: 100%;
  background-size: 100% 100%;
}

.db_body {
  height: calc(100% - 50px);
  width: 100%;
  overflow: auto;
  /* background: rgb(231, 242, 252); */
}
</style>


// WEBPACK FOOTER //
// src/components/pages/sz/dataBoardArea/index.vue